import React, { useEffect, useState } from "react";
import SuccessCheckIcon from "../icons/SuccessCheckIcon";
import { JobsDataType } from "../../types/api-response";
import { folderPagePath, formatDate } from "../../utils";
import AdditionalContent from "./AdditionalContent";
import EditIcon from "../../resources/images/icons/EditIcon";
import DownloadXls from "../../resources/images/icons/DownloadXls";
import CopyIcon from "../../resources/images/icons/CopyIcon";
import getMappedJobType from "../common/utils/getMappedJobType";
import CommonEmptyState from "./CommonEmptyState";
import DownloadXlsModal from "../mjpModals/DownloadXlsModal";
import { useAppSelector } from "../../redux/store";
import { JOB_TITLE_CHAR_LIMIT_ELLIPSIS } from "../../constants/tabs";
import { PASSIVE_JOB } from "../../constants/Filters";
import {Questionnaire} from "@foundit/questionnaire/dist/Questionnaire"
import "../../../node_modules/@foundit/questionnaire/dist/Questionnaire.css";
import { MIDDLEWARE } from "../../constants/api";
import FolderName from "./FolderName";

interface Props {
  jobsData: JobsDataType[] | undefined;
  onDClick?: Function;
  triggerInventory:Function;
emailData?:any
}

const Scheduled = ({ jobsData,onDClick=()=>{},triggerInventory,emailData}: Props) => {
  const [clickedRow, setClickedRow] = useState<number | null>(null);
  const [infocus, setInfocus] = useState<number | null>(null);
  const [openQuestionnaire, setOpenQuestionnaire] = useState<boolean>(false);
  const [currentJobId, setCurrentJobId] = useState<Number | null>(null);
  const openModal: any = useAppSelector((state:any)=>state?.download?.openModal)
  const handleEllipsesClick = (item: number) => {
    setClickedRow((prevClickedRow) => (prevClickedRow === item ? null : item));
  };

  if((jobsData || []).length === 0){
    return <CommonEmptyState text="You have not scheduled any job!"/>
  }

  return (
  <>
    <Questionnaire 
      platform={"MJP"} 
      questionnaireId={currentJobId} 
      middleware={MIDDLEWARE} 
      showSideBar={openQuestionnaire} 
      setShowSideBar={setOpenQuestionnaire}
      isExpired={true}
    />

    <div className="search-result_container">
      {(jobsData || []).map((job, index) => {
         const {
          jobId, 
          title, 
          jobType, 
          hasScreening,
          postedDate,
          renewalDate,
          recruiterName,
          location,
          folderName,
          views,
          startDate,
          updateDate,
          jobPostingType,
          jobFrom
        } = job || {};

        const isRenewed = Number(renewalDate?.length) > 0;

        return (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div id={String(jobId)} 
            className={`search-result_card${infocus==jobId ? ' infocus': ''} ${index===0 ? 'first-rounded' : ''}`}
            >

            <div className="search-result_card_rt">
              <div className="search-result_title-container">
                <div className="search-result_card_row">
                  <span 
                   className={`main_title clickable${title?.length > JOB_TITLE_CHAR_LIMIT_ELLIPSIS ? " allow_ellipsis":""}`}
                   role="button"
                   onClick={()=>window.open(
                     `${window.location.origin}/edge/${folderPagePath}?folderID=${jobId}&autoMatch=false${jobFrom && jobFrom === PASSIVE_JOB ? '&tab=inbound':''}`,
                     "_blank"
                     )}
                  >{title}</span>
                <span className="faded subtitle">({`${jobPostingType=='SJS' ? getMappedJobType('SOCIAL') : getMappedJobType(jobType?.name)}`})</span>
                {jobFrom === PASSIVE_JOB ? <span className="inboundTag">Inbound Jobs</span> : null}
                </div>
               
                {jobFrom !== PASSIVE_JOB && <>{hasScreening ? (
                   <button
                     className="foundit-button secondaryButton small search-result_non-clickable-questionnaire"
                     style={{minWidth: "140px"}}
                        onClick={() =>{
                          setCurrentJobId(jobId);
                          setOpenQuestionnaire(true);
                        }
                        }
                 >
                      <span className="flex-center">
                        <span style={{ marginRight: "4px"}}
                        >Questionnaire</span>
                        <SuccessCheckIcon />
                      </span>
                      </button>
                    ) : (
                      <button
                      className="foundit-button secondaryButton small search-result_screening search-result_non-clickable"
                        onClick={() => {}}
                        style={{minWidth: "140px"}}
                    >
                      <span
                        role="button"
                        onClick={() =>
                          window.open(
                            `${window.location.origin}/edge/jobposting/manage-questionnaire?jobID=${jobId}`,
                            "_blank"
                          )
                        }
                      >
                        Add Questionnaire
                      </span>
                </button>
                    )}</>}
              </div>

              <div className="list_title_container">
                <div
                  style={{
                    display: "flex",
                    fontSize: "12px",
                    margin: "6px 0",
                    lineHeight: "20px",
                  }}
                >
                   <div className='mjp_label_container'>
                    <span className='faded mjp_label'>Posted on:</span>
                    <span className="mjp_value"> {postedDate ? formatDate(postedDate) : '-'}</span>
                   </div> 
                   <div className="vertical_line" />
                  {!isRenewed ? (postedDate == updateDate ? 
                  null :
                  <>
                    <div className='mjp_label_container'>
                      <span className='faded mjp_label'>Edited on:</span>
                      <span className="mjp_value"> {updateDate ? formatDate(updateDate) : '-'}</span>
                    </div>
                    <div className="vertical_line" />
                  </>
                    ) :
                    <>
                    <div className='mjp_label_container'>
                      <span className='faded mjp_label'>Renewed on:</span> 
                      <span className="mjp_value">{renewalDate ? formatDate(renewalDate) : '-'}</span>
                    </div> 
                    <div className="vertical_line" />
                    </>
                  }
                 

                  {jobFrom !== PASSIVE_JOB ? <>
                  <div className='mjp_label_container'>
                  <span className="faded mjp_label">Posted by:{' '}</span><span className="mjp_value">{recruiterName}</span>
                  </div>
                  <div className="vertical_line" />
                  </> : null}

                  <div className='mjp_label_container'>
                  <span className="faded mjp_label">Location:{' '}</span> 
                  < span className="mjp_value">{location?.replace(/,(?!\s)/g, ', ') || ''}</span>
                  </div>
                </div>
              </div>

              <div className="horizontal_seperator" />

              <div className="search-result_card_row">
                <div className="folder_table_container">
                  <div className="folder_table_item">
                    <div className="folder_column faded">Folder</div>
                  <div className="main_title folder-name cp-cursor"
                    onClick={() =>
                      window.open(
                        `${window.location.origin}/edge/${folderPagePath}?folderID=${jobId}&autoMatch=false${jobFrom && jobFrom === PASSIVE_JOB ? '&tab=inbound':''}`,
                        "_blank"
                      )
                    }
                  >
                    <FolderName title={folderName}>
                        {folderName}
                    </FolderName>
                      </div>
                  </div>

                  <div className="folder_table_item">
                    <div className="folder_column faded">Views</div>
                    <div className="main_title">{views}</div>
                  </div>

                  <div className="folder_table_item">
                    <div className="folder_column faded">Last Modification</div>
                  <div className="main_title">{formatDate(updateDate)}</div>
                  </div>

                  <div className="folder_table_item">
                    <div className="folder_column faded">Schedule for</div>
                  <div className="main_title">{formatDate(startDate)}</div>
                  </div>
                </div>

                <div className="search-result_flex">
                  <div
                    role="button"
                    className="search-result_active-icons"
                    onClick={() =>
                      window.open(
                        `${window.location.origin}/edge/jobposting/new-job-posting/edit/${jobId}`,
                        "_blank"
                      )
                    }
                  >
                    <EditIcon/>
                    </div>
                    <div
                      role="button"
                      className="search-result_active-icons"
                      title="Copy"
                      onClick={() =>
                        window.open(
                          // `${window.location.origin}/v4/jobposting/copy/${jobId}`,
                          `${window.location.origin}/edge/jobposting/new-job-posting/copy/${jobId}`,
                          "_blank"
                        )
                      }
                    >
                      <CopyIcon/>
                    </div>
                  <div
                    role="button"
                    className="search-result_active-icons"
                    onClick={(e)=>{
                      onDClick(jobId,e)
                    }}
                  >
                    <DownloadXls/>
                  </div>
                  <div
                    role="button"
                    className="search-result_active-icons"
                    onClick={() => {
                      if(infocus == null) {
                        setInfocus(jobId)
                        handleEllipsesClick(jobId)
                      }
                    }}
                  >
                     <span className="menu-3-dots"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {clickedRow === jobId && (
            <AdditionalContent 
              selectedRowData={[job]} 
              setClickedRow={setClickedRow}
              callbackOnClose={() => setInfocus(null)}
              />
          )}
          {!!openModal && sessionStorage.getItem("mjpKey") == jobId.toString()  &&
          <DownloadXlsModal
          key={jobId+index}
            id={jobId}
            triggerInventory={triggerInventory}
            />
                  }
        </div>
      )}
      )}
    </div>
  </>
  );
};

export default Scheduled;
